module.exports = __webpack_public_path__ + "static/media/twitter-link.9dfbaee0.svg";